/*!
 * Autocomplete Rails JS (https://github.com/kamui/autocomplete-rails)
 * Provides jQuery UI autocomplete bindings for Rails
 * Licensed under the MIT License
 */
$(document).on('turbolinks:load ready page:load', function () {
    $('input[data-autocomplete-url]').each(function () {
      const $input = $(this);
      const url = $input.data('autocomplete-url');
  
      if (!$input.data('ui-autocomplete')) {
        $input.autocomplete({
          source: url,
          minLength: 2
        });
      }
    });
  });
  